import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  $bgType?: 'white' | 'black';
  $colGap?: number;
  $rowGap?: number;
  /** 접힌 상태에서 보여줄 높이(px). null 이면 접을 만큼 길지 않다는 뜻 */
  $foldHeight?: number | null;
}

export const WrapMenuBar = styled.div<IProps>`
  position: relative;

  /* 색은 올려 두는 배경에 맞춰 갈린다 */
  ${({ $bgType }) =>
    $bgType === 'black'
      ? css`
          --fold-bg: #0f0f0f;
          --fold-bg-transparent: rgba(15, 15, 15, 0);
          --fold-btn-border: #e2e2e2;
          --fold-btn-icon: #fff;
        `
      : css`
          --fold-bg: #fff;
          --fold-bg-transparent: rgba(255, 255, 255, 0);
          --fold-btn-border: #e2e2e2;
          --fold-btn-icon: #000;
        `}

  .wrap-menubar-list {
    ${mixin.flex({ wrap: 'wrap', align: 'flex-start', justify: 'flex-start' })};
    column-gap: ${({ $colGap }) => $colGap}px;
    row-gap: ${({ $rowGap }) => $rowGap}px;
    overflow: hidden;
  }

  &.is-folded .wrap-menubar-list {
    max-height: ${({ $foldHeight }) =>
      $foldHeight ? `${$foldHeight}px` : 'none'};
  }

  /* 펼치기 버튼 : 마지막으로 보이는 줄의 오른쪽 끝에 붙는다 */
  .btn-fold-wrap {
    ${mixin.flex({ justify: 'flex-end' })};
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 64px;
    height: 46px;
    background: var(--fold-bg);

    /* 버튼 왼쪽에서 잘린 탭이 배경으로 사라지게 */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 100%;
      width: 20px;
      height: 100%;
      background: linear-gradient(
        270deg,
        var(--fold-bg) 29.17%,
        var(--fold-bg-transparent) 100%
      );
    }
  }

  .btn-fold {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 1px solid var(--fold-btn-border);

    svg path {
      fill: var(--fold-btn-icon);
    }
  }
`;
